import React from 'react';
import { Users, Activity, AlertCircle, Crown } from 'lucide-react';
import StatsCard from './StatsCard';

interface StatsGridProps {
  stats: {
    totalUsers: number;
    activeUsers: number;
    newUsers: number;
    premiumUsers: number;
    totalReports: number;
  };
}

const StatsGrid: React.FC<StatsGridProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4">
      <StatsCard
        title="Total Users"
        value={stats.totalUsers}
        description="Total registered users"
        icon={Users}
      />
      <StatsCard
        title="Active Users"
        value={stats.activeUsers}
        description="Active in the last 7 days"
        icon={Activity}
        trend={{
          value: Math.round((stats.activeUsers / stats.totalUsers) * 100),
          isPositive: true,
        }}
      />
      <StatsCard
        title="New Users"
        value={stats.newUsers}
        description="Joined in the last 7 days"
        icon={Users}
      />
      <StatsCard
        title="Premium Users"
        value={stats.premiumUsers}
        description={`${Math.round((stats.premiumUsers / stats.totalUsers) * 100)}% of total users`}
        icon={Crown}
      />
      <StatsCard
        title="Active Reports"
        value={stats.totalReports}
        description="Element and issue reports"
        icon={AlertCircle}
      />
    </div>
  );
};

export default StatsGrid;
